import { ActiveProduct } from '../../../models/ActiveProduct';
import { ExtendedProducts } from '../../../models/ExtendedProducts';

export const GET_ACTIVE_PRODUCTS = 'GET_ACTIVE_PRODUCTS';

export const GET_EXTENDED_PRODUCTS = 'GET_EXTENDED_PRODUCTS';

export interface IGetActiveProductsAction {
    type: typeof GET_ACTIVE_PRODUCTS;
    payload: { activeProducts: ActiveProduct[] };
}

export interface IGetExtendedProductsAction {
    type: typeof GET_EXTENDED_PRODUCTS;
    payload: { extendedProducts: ExtendedProducts };
}

export type ProductActions = IGetActiveProductsAction | IGetExtendedProductsAction;
